import {
  fork,
} from 'redux-saga/effects';

import submitQuoteWatcher from './submitQuoteWatcher';

export default function* root() {
  yield fork(submitQuoteWatcher);
}
